<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesPrdShiftPlanResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      with-custom-row-actions-first-column
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button
                                            type="gotoChild"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="查看生产实绩"
                                            :busy="gotoLoading"
                                            @click="gotoChildPage(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author liang gang qiang
// Date 2021-10-14 10:06:24

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";

export default {
    name: "mintalMesPrdShiftPlanListView",
    mixins: [emCommonListMixin, emCommonGotoMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    data() {
        return {
            locationTag: -1,
            selectedRow: null,
            gotoLoading: false
        }
    },
    methods: {
        gotoChildPage(row) {
            this.selectedRow = row;
            this.queryLocationTag();
        },
        queryLocationTag() {
            this.gotoLoading = true;
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_MINTALMES_PRD_URL + "/mintalMesPrdShiftPlan/locationTag?locationId=" + this.selectedRow.locationId
            }).then(response => {
                console.log(response);
                this.locationTag = response;
                this.doGoto();
            }).finally(() => this.gotoLoading = false)
        },
        doGoto() {
            let customVuexName = '';
            if (this.locationTag === 1 || this.locationTag === 2) {
                customVuexName = this.isPelletizing(this.locationTag) ? 'Pelletizing' : 'Smelting';
            } else {
                this.$message.warning('location type not valid')
                return;
            }
            this.$_emGotoMixin_gotoHolderList("mintalMesPrdProductionResult"
                , {prdShiftPlanIdFilter: this.selectedRow.id}
                , {prdShiftPlanId: this.selectedRow.id}, false, {shiftPlanId: this.selectedRow.id}, undefined,
                undefined, customVuexName === '' ? undefined : customVuexName + "Entity",
                'mintalMesPrdProduction' + customVuexName + 'ResultList');
        },
        isPelletizing(type) {
            return type === 1;
        },
    }
};
</script>